import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import { tabs } from './tab'

const List = () => {
    const { t } = useTranslation()
    const { TabComponent, TabProps } = useTabs({ tabs })

    return (
        <div>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.documentList,
                        title: t('document_share'),
                    },
                ]}
            />
            <Tabs {...TabProps} />
            {TabComponent}
        </div>
    )
}

export default List
